import { ReactNode } from 'react';
import InputHeader, { InputHeaderProps } from './InputHeader';

export interface FormLayoutProps {
  className?: string;
  children?: ReactNode;
}

const FormLayout = ({ className, children }: FormLayoutProps) => (
  <div
    className={[
      'grid grid-cols-2 grid-rows-[repeat(fit-content,min-content)] gap-x-6',
      className,
    ]
      .filter(Boolean)
      .join(' ')}
  >
    {children}
  </div>
);

export default FormLayout;

export interface FormLayoutInputElementProps extends InputHeaderProps {
  headerClassName?: string;
  label?: ReactNode;
  small?: boolean;
}

export const FormLayoutElement = ({
  children,
  className,
  small,
}: {
  className?: string;
  children?: ReactNode;
  small?: boolean;
}) => (
  <div
    className={[
      'mb-4 row-span-2 col-span-full',
      small && 'md:col-span-1',
      className,
    ].join(' ')}
  >
    {children}
  </div>
);

export const FormLayoutInputElement = ({
  children,
  className,
  label,
  headerClassName,
  small,
  ...restOfInputHeaderProps
}: FormLayoutInputElementProps) => (
  <label
    className={[
      'mb-4 row-span-2 col-span-full grid grid-rows-subgrid',
      small && 'md:col-span-1',
      className,
    ].join(' ')}
  >
    <InputHeader
      {...restOfInputHeaderProps}
      className={[headerClassName].join(' ')}
    >
      {label}
    </InputHeader>
    <div>{children}</div>
  </label>
);
